export default __webpack_public_path__ + "static/media/Crown.fc1a863b.svg";